import React, { useEffect, useState } from "react";
import moment from "moment";
import Currency from "react-currency-formatter";

import {
  Container,
  Title,
  ItemDetails,
  DownloadButton,
  DownloadIcon,
  Left,
  Right,
  TitleDetails,
  Divisor,
  Details,
  IconInformation,
  ToolTipButton,
  ToolTipText,
  PixContainer,
} from "./styles";
import { handleStatus } from "~/utils/functions/bankSlips";
import information from "~/assets/images/information.svg";
import api from "~/services/api";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as InvoiceActions } from "~/store/ducks/invoice";
import ReactTooltip from "react-tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { analytics, logEvent } from '~/services/firebaseConfig'
import pix from '~/assets/images/pix-blue.svg';

function BankslipsDesktop({ data, openModal, login_email }) {
  const installment = data;
  const invoice = data.invoice;
  const [selectedPixCode, setSelectedPixCode] = useState("")
  const status = handleStatus(data);
  const storeInfo = localStorage.getItem("codeStore").split("-");
  const customer = {
    code: storeInfo[0],
    siteCode: storeInfo[1],
  };

  function requestDownloadBoleto() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: "POST",
      responseType: "blob",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: "DOWNLOAD",
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${installment.installmentId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          } else {
            localStorage.clear();
            window.location.href = "/acessar?error";
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }

  function requestEmailBoleto() {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("access_token"),
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: "EMAIL",
      email: login_email,
      contactIdSf: localStorage.getItem("contactIdSf"),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((res) => {
        if (res.status) {
          if (res.status === 204) {
            toast.success(`Boleto enviado para o e-mail: ${login_email}`);
          }
        }
      })
      .catch((err) => {});
  }

  function handleCopyToClickBoard(selectedPixCode) {
    logEvent(analytics, 'copiando_linha_digitavel')
    return setSelectedPixCode(selectedPixCode);
  }

  let qrcodeData = null

  try {
    if ('qrcodeData' in installment) {
      qrcodeData = JSON.parse('{' + installment.qrcodeData + '}');
    }
  } catch (error) {
    console.log('Erro ao converter QRCode');
  }

  return (
    <Container
      className="mb-3"
      style={{
        cursor: !installment.paymentTypeBoleto ? "pointer" : "normal",
      }}
    >
      <Left>
        <Title>{moment(installment.dueDate).format("MMMM/YYYY")}</Title>
        <ItemDetails style={{ justifyContent: "start", width: 100 }}>
          <span
            style={{
              fontSize: "10px",
              color:
                status === "Pago"
                  ? "#75B943"
                  : status === "Vencido"
                    ? "#e34e2a"
                    : status === "A Vencer"
                      ? "#f0b01b"
                      : "#000",
            }}
            className="mdi mdi-checkbox-blank-circle mr-1"
          />
          {status}
        </ItemDetails>
        <ItemDetails>
          <TitleDetails>Vencimentos:</TitleDetails>{" "}
          {moment(installment.dueDate).format("DD/MM/YYYY")}
        </ItemDetails>
      </Left>

      <Right>
        {status !== "Pago" && qrcodeData?.dados_qrcode?.emv && (
          <PixContainer>
            <CopyToClipboard text={qrcodeData?.dados_qrcode?.emv}>
              <ToolTipButton
                onClick={() => handleCopyToClickBoard(qrcodeData?.dados_qrcode?.emv)}
                data-tip
                data-for={invoice.invoiceId}
              >
                <img src={pix} alt="Debito no pedido" />
              </ToolTipButton>
            </CopyToClipboard>
            {selectedPixCode === qrcodeData?.dados_qrcode?.emv ? (
              <ReactTooltip id={invoice.invoiceId} place="right" type="dark" effect="solid">
                <ToolTipText>Copiado</ToolTipText>
              </ReactTooltip>
            ) : (
              <ReactTooltip id={invoice.invoiceId} place="right" type="dark" effect="solid">
                <ToolTipText>Clique para copiar</ToolTipText>
              </ReactTooltip>
            )}
          </PixContainer>
        )}
        {installment.paymentTypeBoleto && (
          <>
            <DownloadButton className="mr-2">
              <DownloadIcon
                className="mdi mdi-download"
                onClick={() => requestDownloadBoleto()}
              />
            </DownloadButton>
            <DownloadButton>
              <DownloadIcon
                className="mdi mdi-email"
                onClick={() => requestEmailBoleto()}
              />
            </DownloadButton>
            <Divisor />
          </>
        )}

        <Title>
          <Currency
            quantity={installment.amountOriginal}
            currency="BRL"
            locale="pt"
          />
        </Title>

        <Details onClick={() => openModal()}>
          Detalhes
          <img src={information} style={IconInformation} />
        </Details>
      </Right>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  modalInformation: state.invoiceReducer.modalInformation,
  access_token: state.loginReducer.access_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(InvoiceActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BankslipsDesktop);
